function initTabSelectors() {
  class TabSelectors {
    constructor(container) {
      this.container = container;
      this.tabSelectors = this.container.querySelectorAll('.bb-pro-tab-selector');
      this.desktopButton = this.container.querySelector('.desktop-learn-button');
      this.init();
    }

    init() {
      if (!this.tabSelectors.length || !this.desktopButton) return;
      this.setupEventListeners();
    }

    updateButtonText(tabId) {
      if (tabId === 'ps-remote') {
        this.desktopButton.textContent = 'Learn how PS Remote Play works';
      } else if (tabId === 'xbox-pass') {
        this.desktopButton.textContent = 'Learn how XBOX Game Pass works';
      } else if (tabId === 'steam-link') {
        this.desktopButton.textContent = 'Learn how Steam Link works';
      } else if (tabId === 'apple-arcade') {
        this.desktopButton.textContent = 'Learn how to play Apple Arcade games';
      } else if (tabId === 'google-play') {
        this.desktopButton.textContent = 'Learn how Google Play works';
      } else if (tabId === 'emulator-games') {
        this.desktopButton.textContent = 'Learn how Emulator Games work';
      }
    }

    setupEventListeners() {
      this.tabSelectors.forEach((selector) => {
        selector.addEventListener('click', (event) => {
          this.tabSelectors.forEach((tab) => tab.classList.remove('active'));
          selector.classList.add('active');

          const tabToShow = selector.getAttribute('data-tab');

          const tabContents = this.container.querySelectorAll('.bb-pro-tab-content');
          tabContents.forEach((content) => content.classList.remove('active'));

          const tabContent = this.container.querySelector(`#${tabToShow}`);
          if (tabContent) {
            tabContent.classList.add('active');
          }

          this.updateButtonText(tabToShow);
        });
      });
    }
  }

  const tabContainers = document.querySelectorAll('.bb-pro-tab-selector-container');
  tabContainers.forEach((container) => {
    new TabSelectors(container);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  const hasTabSelectors = document.querySelectorAll('.bb-pro-tab-selector').length > 0;
  if (hasTabSelectors) {
    initTabSelectors();
  }
});
